/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { inject, observer } from 'mobx-react';
import { withTranslation, useTranslation } from 'react-i18next';
import withCustomComponent from 'ui/components/withCustomComponent';
import ActionButton from '../../../components/forms/ActionButton';

const BookingNotesForm = ({
  bookingsStore,
  isSidePopup,
  updateBooking,
  appStore,
  t,
}) => {
  const [showNoteField, setShowNoteField] = useState(false);
  const { booking, saveBooking, isSavingBookingToUpdate } = bookingsStore;
  const { setPopMessage } = appStore;
  const handleAddNoteClick = (event) => {
    event.preventDefault();
    setShowNoteField(true);
  };

  if (!booking.ResourceId) return null;

  const waitingForPayment =
    booking.Tentative || booking.CoworkerInvoicePaid == false;

  return (
    <>
      {!booking.Notes && !showNoteField && (
        <a
          href="#"
          className="btn btn-gray btn-icon btn-sm-sm mr-8 my-4"
          onClick={handleAddNoteClick}
        >
          <i className="icon-note"></i>
          {t('Add Note')}
        </a>
      )}

      {(booking.Notes || showNoteField) && (
        <div className="form-group">
          <label className="fs-18">{t('Note')}</label>
          {waitingForPayment && (
            <div className="text-danger fs-14 mb-8">
              You can update notes once the booking is confirmed.
            </div>
          )}

          <textarea
            rows="3"
            id={isSidePopup ? 'js--input' : ''}
            className="form-control"
            value={booking.Notes}
            onChange={(ev) => updateBooking('Notes', ev.target.value)}
            placeholder={t('Type any notes for this booking ...')}
            disabled={waitingForPayment}
          ></textarea>
          {booking.Id > 1000 && ( // only show update button for bookings that have been saved
            <UpdateNoteButton
              booking={booking}
              saveBooking={saveBooking}
              isSavingBooking={isSavingBookingToUpdate}
              disabled={waitingForPayment}
              setPopMessage={setPopMessage}
            />
          )}
          <hr className="my-24" />
        </div>
      )}
    </>
  );
};

export default withCustomComponent('BookingNotesForm')(
  withTranslation()(
    inject('appStore', 'bookingsStore')(observer(BookingNotesForm))
  )
);

const UpdateNoteButton = ({
  booking,
  saveBooking,
  isSavingBooking,
  disabled,
  setPopMessage,
}) => {
  const { t } = useTranslation();

  const handleUpdateNoteClick = async () => {
    saveBooking();
  };

  return (
    <div className="d-flex justify-content-end">
      <ActionButton
        className={`btn btn-sm mt-16`}
        label={t('Update note')}
        action={handleUpdateNoteClick}
        busy={isSavingBooking}
        disabled={disabled}
      />
    </div>
  );
};
